import { computed, type MaybeRefOrGetter, toValue } from "vue";
import { useQuery } from '@tanstack/vue-query'
import getUserDetails from '@/features/users/get-user-details'
import hasPermission, { AccessArea, AccessRight } from '@/features/users/has-permission'
import hasAbility from "@/features/users/has-ability";

export { AccessArea, AccessRight }

export default function useUserDetails(id: MaybeRefOrGetter<string | undefined>) {
  const staleTime = computed(
    () => toValue(id) === 'me' ? 60_000 : undefined
  )

  const query = useQuery({
    queryKey: ['users:details', id],
    staleTime,
    enabled: () => toValue(id) !== undefined,
    queryFn: () => getUserDetails(toValue(id)!)
  })

  return {
    ...query,
    hasPermission: (area: AccessArea, ...rights: AccessRight[]) => {
      const user = query.data.value

      if (user === undefined) {
        return false
      }

      return hasPermission(user.permissions, area, ...rights)
    },
    hasAbility: (ability: Parameters<typeof hasAbility>[1]) => {
      const user = query.data.value

      if (user === undefined) {
        return undefined
      }

      return hasAbility(user.permissions, ability)
    }
  }
}
